import type { ReactNode } from 'react'

import { Alert } from '../feedback/alert/Alert'
import { useTranslate } from '../hooks/useTranslate'
import { IMAGE_EXTENSIONS, VIDEO_EXTENSIONS } from './constants'
import { MarkdownImage } from './MarkdownImage'
import { MarkdownVideo } from './MarkdownVideo'

export type MediaComponentProps = {
  src?: string
  alt?: string
  children?: ReactNode
}

export const MarkdownMedia = ({ src, alt }: MediaComponentProps) => {
  const translate = useTranslate()
  if (!src) {
    return null
  }

  if (
    ![...VIDEO_EXTENSIONS, ...IMAGE_EXTENSIONS].find((ext) =>
      src.toLowerCase().endsWith(ext),
    )
  ) {
    return (
      <p className="flex gap-x-2 items">
        <Alert severity="error" variant="mini" />
        <span>{src}</span>
        <span>({translate('markdownViewer.media.unsupportedFormat')})</span>
      </p>
    )
  }

  const isVideo = VIDEO_EXTENSIONS.some((ext) =>
    src.toLowerCase().endsWith(ext),
  )

  return isVideo ? (
    <MarkdownVideo src={src} alt={alt} />
  ) : (
    <MarkdownImage src={src} alt={alt} />
  )
}
